import { FC } from "react";
import styled from "styled-components";
import { Tag as BPTag } from "@blueprintjs/core";

interface TagCellProps {
  tags: string[];
}

const Tag = styled(BPTag)`
  margin-right: 4px;
`;

export const TagCell: FC<TagCellProps> = ({ tags }) => {
  return (
    <div>
      {tags.length > 0 ? (
        tags.map((tag, idx) => <Tag key={idx}>{tag}</Tag>)
      ) : (
        <span></span>
      )}
    </div>
  );
};
